import React from "react";

function Logo () {
    return (
        <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span className="bar-icon" />
            <span className="bar-icon" />
            <span className="bar-icon" />
        </button>
    );
  }


export default Logo;
